// Site Footer

import './index.scss';

export default class SiteFooter {
    constructor(root) {
        this.root = root;
        this.root.querySelectorAll('.site-footer__linksmenu .list')
            .forEach((list) => { this.initList(list); });
    }

    initList(list) {
        const caption = list.querySelector('.caption');
        const wrapper = list.querySelector('.wrapper');

        caption.addEventListener('click', (event) => {
            if (window.innerWidth >= window.breakpoint.sm) { return; }
            event.preventDefault();

            if (list.classList.contains('opened')) {
                list.classList.remove('opened');
                wrapper.style.maxHeight = null;
            } else {
                list.classList.add('opened');
                wrapper.style.maxHeight = wrapper.scrollHeight + 'px';
            }
        });
    }
}
